export type ErrorContext = {
  url: string;
  route: string;
  token: string;
  userAgent: string;
  timestamp: string;
  appVersion: string;
};

export const buildErrorContext = (): ErrorContext => ({
  url: window.location.href,
  route: window.location.pathname,
  token: window.location.pathname.split("/")[1] ?? "unknown",
  userAgent: navigator.userAgent,
  timestamp: new Date().toISOString(),
  appVersion: import.meta.env.VITE_APP_VERSION ?? "unknown",
});
